import React, { Dispatch, SetStateAction } from 'react';
import { Pressable } from 'react-native';
import Modal from '../Modal';
const AlertIcon = require("../../../assets/info.svg");

import {
  Container,
  Content,
  Title,
  Description,
  Actions,
  TextButton,
  IconAlert
} from './styles';

interface ModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  description: string;
  action?: () => void;
  testID?: string;
}

export const ModalNotBarcode: React.FC<ModalProps> = ({
  isOpen,
  setIsOpen,
  title,
  description,
  action,
  testID,
}) => {
  const modalAction = () => {
    action && action();
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      testID={testID}
      onClose={() => setIsOpen(false)}
    >
      <Container>
      <IconAlert source={AlertIcon} resizeMode="contain"/>
        <Content>
          <Title testID="modal_title">{title}</Title>
          <Description testID="modal_description">{description}</Description>
        </Content>

        <Actions>
          <Pressable
            onPress={() => setIsOpen(false)}
            style={{
              width: '50%',
              padding: 20,
              alignItems: 'center',
              justifyContent: 'center',
              borderRightWidth: 1,
              borderRightColor: '#949494',
            }}
            testID="modal_cancel_btn"
          >
            <TextButton>CANCELAR</TextButton>
          </Pressable>
          <Pressable
            onPress={modalAction}
            style={{
              width: '50%',
              padding: 20,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            testID="modal_ok_button"
          >
            <TextButton>PESQUISAR</TextButton>
          </Pressable>
        </Actions>
      </Container>
    </Modal>
  );
};

export default ModalNotBarcode;
